import { fetchWithAuth } from "./fetchWithAuth";

export async function loadOrderOptions(inputValue: string) {
  try {
    const response = await fetchWithAuth(`/orders?search=${encodeURIComponent(inputValue)}`);
    const data = await response.json();

    return (data.orders ?? []).map((order: any) => ({
      label: `${order.identifier}`,
      value: order.id,
      customerId: order.customer_id,
    }));
  } catch {
    // fetchWithAuth already surfaced the error; the select just shows no options.
    return [];
  }
};
